import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { ScrBaseService } from "./base.service";
import { ScrServiceManager } from "./servicemanager.service";

/**
 * Cache "stuff" on the client.
 */



export class EntityCacheEntry<K, V> {

  public timestamp: Date;

  constructor(public key: K, public entity: V, public expiryMilliSeconds = 120_000) {
    this.timestamp = new Date();
  }
}

export class EntityCache<K, V> {
  private map: Map<K, EntityCacheEntry<K, V>>;
  constructor() {
    this.map = new Map();
  }

  /*
  asAny(): any {
    const rv: any = {};
    this.map.forEach((e) => {
      rv[e.key] = e.entity;
    });
    return rv;
  }*/

  keys(): IterableIterator<K> {
    return this.map.keys();
  }

  has(k: K): boolean {
    return this.map.has(k);
  }

  public get(k: K, ignoreExpiry = false): V | undefined {
    const entry = this.map.get(k);
    if (!entry) {
      return undefined;
    }
    else {
      const now = new Date();
      const diff = now.valueOf() - entry.timestamp.valueOf();
      if (!ignoreExpiry && (diff > entry.expiryMilliSeconds) && entry.expiryMilliSeconds !== 0) {
        // console.debug('cache expire ' + k);
        this.map.delete(k);
        return undefined;
      }
      return entry.entity;
    }
  }

  public clear() {
    // console.debug('catch entity clear');
    this.map.clear();
  }

  public put(k: K, v?: V, expiryMilliSeconds = 120_000): void {
    if (!k) {
      return;
    }
    // console.debug('cache entity put ' + k + ' ' + v);
    if (v) {
      const entry = new EntityCacheEntry<K, V>(k, v, expiryMilliSeconds);
      this.map.set(k, entry);
    }
    else {
      this.map.delete(k);
    }
  }
}


@Injectable({
  providedIn: 'root'
})
export class CacheService extends ScrBaseService {

  private cache: EntityCache<string, object>;
  private master: BehaviorSubject<EntityCache<string, object>>;

  constructor(
    serviceManager: ScrServiceManager) {
    super(serviceManager);

    this.cache = new EntityCache();
    this.master = new BehaviorSubject<EntityCache<string, object>>(this.cache);
  }


  public get<T>(key: string): T {
    return this.cache.get(key) as unknown as T;
  }

  public subscribe<T>(key: string): Observable<T> {
    // console.debug('someone is subscribing for ' + key + ' should see emit since this is beh sub');
    // console.debug(JSON.stringify(this.master.value));
    return this.master.pipe(
      filter(cache => {
        return cache.has(key);
      }),
      map(cache => {
        const rv = cache.get(key) as unknown as T;
        return rv;
      }));
  }

  public clear() {
    // console.debug('cache clear');
    this.cache.clear();
    this.master.next(this.cache);
  }

  public set<T extends object>(k: string, v?: T, expiryMilliSeconds = 120_000): void {
    // console.debug('cache set ' + k + ' ' + v);
    this.cache.put(k, v, expiryMilliSeconds);
    //    this.master.next({k,v});
    this.master.next(this.cache);
  }

  public invalidate(key: string, publishChange = true): void {
    // console.debug('cache invalidate ' + key);
    if (this.cache.has(key)) {
      this.cache.put(key, undefined);
      if (publishChange) {
        //        this.master.next({k:key,v:undefined});
        this.master.next(this.cache);
      }
    }
  }
}
